import React from 'react';
import PropTypes from 'prop-types';
import { Column } from 'components/shared/Layout';
import { StyledHeader, Heading } from './SectionHeaderBar.styles';

const SectionHeaderBar = ({ children }) => (
  <StyledHeader span={16} gutter="24px" alignItems="center">
    <Column span={6}>
      <Heading>{React.Children.toArray(children)[0]}</Heading>
    </Column>
    <Column span={4} start={11} justifyContent="flex-end">
      <Heading>{React.Children.toArray(children)[1]}</Heading>
    </Column>
    <Column span={2} start={15} justifyContent="flex-end">
      <Heading>{React.Children.toArray(children)[2]}</Heading>
    </Column>
  </StyledHeader>
);

SectionHeaderBar.propTypes = {
  children: PropTypes.node
};

export default SectionHeaderBar;
